import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ContactPage() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site-settings`).then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const whatsappLink = `https://wa.me/${(settings?.whatsapp_number || '+905444720713').replace(/[^0-9]/g, '')}`;

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="pt-24 pb-24 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-16">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#B026FF]" style={{ fontFamily: 'Outfit, sans-serif' }}>İletişim</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black mt-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="contact-heading">
              Bize Ulaşın
            </h1>
            <p className="text-base sm:text-lg text-[#A1A1AA] mt-4">Sorularınız mı var? Uzman ekibimize ulaşabilirsiniz.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-[#B026FF]/10 rounded-lg flex items-center justify-center flex-shrink-0"><Phone className="w-6 h-6 text-[#B026FF]" /></div>
              <div>
                <h3 className="text-lg font-bold mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Telefon</h3>
                <a href={`tel:${settings?.contact_phone || '+905444720713'}`} className="text-[#A1A1AA] hover:text-white transition-colors">{settings?.contact_phone || '+905444720713'}</a>
              </div>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-[#B026FF]/10 rounded-lg flex items-center justify-center flex-shrink-0"><Mail className="w-6 h-6 text-[#B026FF]" /></div>
              <div>
                <h3 className="text-lg font-bold mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>E-posta</h3>
                <a href={`mailto:${settings?.contact_email || 'info@kargamentorluk.com'}`} className="text-[#A1A1AA] hover:text-white transition-colors">{settings?.contact_email || 'info@kargamentorluk.com'}</a>
              </div>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-[#B026FF]/10 rounded-lg flex items-center justify-center flex-shrink-0"><MapPin className="w-6 h-6 text-[#B026FF]" /></div>
              <div>
                <h3 className="text-lg font-bold mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Adres</h3>
                <p className="text-[#A1A1AA]">{settings?.contact_address || 'Türkiye'}</p>
              </div>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0"><MessageCircle className="w-6 h-6 text-green-500" /></div>
              <div>
                <h3 className="text-lg font-bold mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>WhatsApp</h3>
                <p className="text-[#A1A1AA] text-sm mb-2">Hızlı iletişim için WhatsApp'tan yazın</p>
                <Button onClick={() => window.open(whatsappLink, '_blank')} size="sm" className="bg-green-500 hover:bg-green-600 text-white" data-testid="whatsapp-contact-btn">WhatsApp'a Git</Button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
